/*
 * @Descripttion:
 * @version:
 * @Author: Jianyong Wang
 * @Date: 2020-03-19 18:00:10
 * @LastEditors: zhangyang yang.zhang@corerain.com
 * @LastEditTime: 2023-03-13 10:37:57
 */
import axios from 'axios'
import store from '@/store'
import { message } from 'ant-design-vue'

//  401跳转
function noAuth() {
  console.log('401', store)
  window.localStorage.clear()
  window.location.href = '/'
}

const CancelToken = axios.CancelToken
let cancel
const curRequest: any = {}

//  缓存当前请求  设置存储对象
const setCurRequest = (url: string, data: any = {}, requestCancel: any, isNeedClear) => {
  const keys = Object.keys(data)
  let requestKey = url
  const symbol = '-'
  if (!isNeedClear) {
    keys.forEach((key) => {
      const val = data[key]
      requestKey += symbol + key + symbol + val
    })
  }
  //  清空上一次请求
  if (curRequest[requestKey]) {
    curRequest[requestKey]()
    curRequest[requestKey] = null
  }

  curRequest[requestKey] = requestCancel
}

const cleanRequestList = () => {
  const keys = Object.keys(curRequest)

  keys.forEach((key) => {
    const cancel = curRequest[key]
    cancel && cancel()
    curRequest[key] = null
  })
}
const mode = import.meta.env.MODE

// 环境
const request = (opt: any) => {
  const { method, url, params, data, baseUrl = '/v1', cancelToken, onUploadProgress } = opt
  opt.notErrTips = false
  const axiosOptions: any = {
    baseURL: baseUrl,
    method,
    url,
    params, // get
    data, // post
    transformRequest: [
      (data: any) => {
        // 对 data 进行任意转换处理
        if (opt.formData) {
          const formData = new FormData()
          for (const key in data) {
            if (/\[\]$/.test(key)) {
              data[key].forEach((v: any) => {
                formData.append(key, v)
              })
            } else {
              formData.append(key, data[key])
            }
          }
          return formData
        }
        return JSON.stringify(data)
      }
    ],
    headers: (() => {
      const headers = opt.headers || {
        'Content-Type': opt.formData
          ? 'application/x-www-form-urlencoded;charset=UTF-8'
          : 'application/json; charset=utf-8'
      }

      return headers
    })(),
    cancelToken:
      cancelToken ||
      new CancelToken(function executor(c) {
        cancel = c
        setCurRequest(url, method.toUpperCase() === 'GET' ? params : data, cancel, opt.isNeedClear)
      }),
    onUploadProgress
  }
  return axios(axiosOptions)
    .then((response) => {
      if (
        (axiosOptions.url === '/apps' && axiosOptions.method === 'get') ||
        axiosOptions.url.indexOf('get_alarm') !== -1 ||
        response.data?.total ||
        response.data?.total === 0
      ) {
        return response.data
      } else {
        const body = response.data
        const data = body && body.data
        const res = data || body || {}

        return res
      }
    })
    .catch((err) => {
      const res = err.response

      if (axios.isCancel(err)) {
        return ''
      }

      if (!res) {
        showErrorMessage(err.message)

        return ''
      }

      const code = res && res.status

      const data = res.data
      const notShowErrMsg: boolean = opt.notShowErrMsg

      const errTips =
        data?.data?.errorMsg ||
        data?.data?.errMsg ||
        data?.errMsg ||
        err.message ||
        err ||
        '出错了，请稍后再试！'

      !notShowErrMsg && showErrorMessage(errTips)

      if (code === 401) {
        noAuth()
        return
      }

      // if (code !== 200 && res.errCode !== 0) {
      //   const errTips = data.data.errMsg
      //   showErrorMessage(errTips)
      // }

      if (notShowErrMsg) {
        return {
          type: 'cusShowError',
          data: data.data || '出错了，请稍后再试！'
        }
      }
      return ''
    })
}

/*
 * @params {string} url 请求地址
 * @params {object} resOpts 请求配置参数
 */
const downloadRequest = (url, resOpts: any = {}) => {
  const { type = 'get', data = '' } = resOpts
  const queryArgs = {
    url,
    method: type,
    data,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json; charset=utf-8',
      withCredentials: true
    }
  }
  // tips: 这里直接返回的是response整体!
  return axios.request(queryArgs).catch((err) => console.log(err))
}

function showErrorMessage(errTips: string) {
  message.error(errTips)
}

export { request, cleanRequestList, downloadRequest }
